
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_nr3gs_n93je_5",
  "textarea": "awsui_textarea_nr3gs_n93je_9",
  "action-button": "awsui_action-button_nr3gs_n93je_13",
  "secondary-actions": "awsui_secondary-actions_nr3gs_n93je_17",
  "secondary-content": "awsui_secondary-content_nr3gs_n93je_21"
};
  